import React from "react";
import { altColor, secondaryTextColorOppositeShade } from "../../utils/constants";

export default function NewMentionInfoIcon({ color = altColor, color2 = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 533.81 533.81">
      <defs>
        <radialGradient
          id="Unbenannter_Verlauf_3"
          cx="266.91"
          cy="-1923.46"
          r="264.22"
          gradientTransform="matrix(1, 0, 0, -1, 0, -1656.55)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color={color} />
          <stop offset="1" stop-color={color} />
        </radialGradient>
      </defs>
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Capa_1" data-name="Capa 1">
          <g id="Ebene_2-2" data-name="Ebene 2">
            <g id="Ebene_1-2" data-name="Ebene 1-2">
              <circle
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth="5.38px"
                fill="url(#Unbenannter_Verlauf_3)"
                cx="266.91"
                cy="266.91"
                r="264.22"
              />
            </g>
          </g>
          <path
            fill={color2}
            d="M395.45,382.91a106.34,106.34,0,0,0,24.83-67.62c0-47-31.94-88.27-77-100.9-2.91-65.57-57.05-118.87-123.73-118.87-68.37,0-124.5,56.12-124.5,124.49,0,29.5,10.73,57.75,30.4,80.5l-27.54,27a9.53,9.53,0,0,0,6.67,16.33H214c12.67,45,53.89,76.85,100.85,76.85h95.92a9.53,9.53,0,0,0,6.66-16.34Zm-267.54-58.1,17.52-17.19a9.53,9.53,0,0,0,.07-13.54c-20.23-20.23-31.37-46.53-31.37-74.07A105.56,105.56,0,0,1,219.57,114.57c57.79,0,104.8,47.3,104.8,105.44a104.91,104.91,0,0,1-104.8,104.8Zm186.93,76.86c-36.87,0-69.44-24.08-81.16-58.61A124.1,124.1,0,0,0,342.62,234.12c34.53,11.72,58.61,44.29,58.61,81.17a87.44,87.44,0,0,1-25.75,61.26,9.53,9.53,0,0,0,.07,13.55l11.83,11.57ZM219.57,153.32A66.69,66.69,0,1,0,241.82,282.9a9.53,9.53,0,0,0-6.36-18A47.64,47.64,0,1,1,267.21,220a9.53,9.53,0,1,1-19.06,0V201a9.52,9.52,0,0,0-9.53-9.53H219.57a28.58,28.58,0,1,0,19.05,49.86A28.57,28.57,0,0,0,286.26,220,66.77,66.77,0,0,0,219.57,153.32ZM229.1,220a9.53,9.53,0,1,1-9.53-9.53h9.53Z"
          />
        </g>
      </g>
    </svg>
  );
}
